<script>
import Popper from "vue3-popper";
import { useToast } from "vue-toastification";


import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getTask, getTaskTypeOptions, getTaskAccountStatesOptions, saveTask, createTask } from '@/services/working/serviceTask';
import { getProjectOptions } from '@/services/working/serviceProject';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'TaskEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		Popper
		,LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'taskId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["taskId","changeRecord"],
	data() {
	
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			optionsAccessLevels: [],
			optionsStates:[],
				
			//form
			data:[],

			optionsTaskTypes: [],
			optionsProjects: [],
			optionsTaskAccountStates: [],
			
		}
	},
	
	mounted:function(){
		
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true

			getTask({taskId:this.taskId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getProjectOptions().then(response => {
				if(!response.statusText){
					this.optionsProjects = response.optionsProjects;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getTaskTypeOptions().then(response => {
				if(!response.statusText){
					this.optionsTaskTypes = response.optionsTaskTypes;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getTaskAccountStatesOptions().then(response => {
				if(!response.statusText){
					this.optionsTaskAccountStates = response.optionsTaskAccountStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		
		onClose:function(){
			this.$emit('changeRecord', '')
			this.modalObject.hide();
		},
		

		checkSave:function(){
								
			if(!this.data.title){this.data.titleError = true; }else{this.data.titleError = false;}
			if(!this.data.status){this.data.statusError = true; }else{this.data.statusError = false;}
			if(!this.data.type){this.data.typeError = true; }else{this.data.typeError = false;}
			if(!this.data.projectId){this.data.projectError = true; }else{this.data.projectError = false;}

			if(!this.data.titleError && !this.data.statusError && !this.data.typeError && !this.data.projectError){
				return true;
			}else{
				return false;
			}
		},	
		
		onSave:function(){
			
			if(this.checkSave()){
				if(this.taskId!='null'){	
					this.isSending=true
					saveTask({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{
					createTask({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}	
			}
			
		}
	
	},
	
	watch: {
		taskId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg modal-dialog-scrollable">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCustomWorking.Task') }} <span v-if="!data.isNewRecord"><b>{{ data.title }}</b> id: {{data.id}}</span></h6>
					</div>
			
							<div v-if="metaData.modulAccess && (auth.tasksEdit || auth.tasksNew)" class="modal-body">
											
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName+', '+data.isCheckedOutDate">
												<button class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</button>
											</Popper>
											
										</div>
									</div>
								</div>

									<div class="form-row">
										
										<div class="form-group col-md-2 col-3">
											<label><b>{{ $t('msgCore.ID') }}</b></label><br>
											{{data.id}}
										</div>
										
										
										<div class="form-group col-md-10 col-12">
											
											<label :class="{'text-danger':data.titleError}"><b>{{ $t('msgCore.title') }}</b> </label>
											<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.titleError}" v-model="data.title" v-on:change="checkSave()" >
											<div v-show="data.titleError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
										</div>
										
										<div class="form-group col-12">
											<label><b>{{ $t('msgCore.request') }}</b> </label>
											<textarea class="form-control form-control-sm" v-model="data.request" rows="4"></textarea>
										</div>
										
										<div class="form-group col-md-12 col-12">
											<label><b>{{ $t('msgCore.description') }}</b> </label>
											<input type="text" class="form-control form-control-sm" v-model="data.description" >
										</div>
										
																					
										<div class="form-group col-md-4 col-12">
											<label :class="{'text-danger':data.typeError}"><b>{{ $t('msgCore.Type') }}</b></label>
																								
											<select v-model='data.type' class="form-control form-control-sm "  :class="{'is-invalid':data.typeError}" v-on:change="checkSave()">
												<option  value="">{{ $t('msgCustomWorking.selectType') }}</option>
												<option v-for="(option) in optionsTaskTypes" :key="option" :value="option.value">{{ $t('msgCustomWorking.'+option.title) }}</option>
											</select>
											<div v-show="data.typeError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectType')}}</span></div>
										</div>
										
										<div class="form-group col-md-4 col-12">
											<label :class="{'text-danger':data.projectError}"><b>{{ $t('msgCustomWorking.Project') }}</b></label>
																								
											<select v-model='data.projectId' class="form-control form-control-sm "  :class="{'is-invalid':data.projectError}" v-on:change="checkSave()">
												<option  value="">{{ $t('msgCustomWorking.selectProject') }}</option>
												<option v-for="(option) in optionsProjects" :key="option" :value="option.value">{{ option.title }}</option>
											</select>
											<div v-show="data.projectError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCustomWorking.selectProject')}}</span></div>
										</div>
										
										<div class="form-group col-md-4 col-12">
											<label :class="{'text-danger':data.statusError}"><b>{{ $t('msgCore.Status') }}</b></label>
																								
											<select v-model='data.status' class="form-control form-control-sm "  :class="{'is-invalid':data.statusError}" v-on:change="checkSave()">
												<option  value="">{{ $t('msgCustomWorking.selectStatus') }}</option>
												<option v-for="(option) in optionsTaskAccountStates" :key="option" :value="option.value">{{ $t('msgCustomWorking.'+option.title) }}</option>
											</select>
											<div v-show="data.statusError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCustomWorking.selectStatus')}}</span></div>
										</div>
										
										
									</div>	
								
									
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12 mt-3">
										<Alert type="warning" :label="$t('msgCore.accessDenied')" />
									</div>
								</div>
							</div>
							
							
							
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									
									<LoadingButton :isDisabled="((!auth.tasksEdit) || (!auth.tasksNew) || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		

	</div>
	

</template>


